import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';

import * as _ from 'lodash';
import GlobalStore from '@/store/modules/global';

import BeneficiarioAuthService from './services/beneficiario.auth.service';
import BeneficiarioCearaAppAuthService from './services/beneficiarioCearaApp.auth.service';
import TransportadoraAuthService from './services/transportadora.auth.service';
import VaiVemAuthService from './services/vai-vem.auth.service';

import { hasInclusionAndFinishedRegister, canRegister } from '@/resolvers/beneficiario.resolver';

import {
  hasInclusionAndFinishedRegisterCearaApp,
  canRegisterCearaApp,
} from '@/resolvers/beneficiarioCearaApp.resolver';

import { BASE_PATH_APP } from '@/commons/config';
import { Beneficiario } from './models/beneficiario';
import vaiVemAuthService from './services/vai-vem.auth.service';
import AuthService from '@/services/sie-pedidos/auth.service';
import authService from './services/gessan/auth.service';


Vue.use(VueRouter);

export const router = new VueRouter({
  base: BASE_PATH_APP,
  routes: [
    {
      path: '/',
      meta: {
        breadcrumb: 'Início',
        publicPage: true,
      },
      component: () => import(/* webpackChunkName: "home" */ './views/Home.vue'),
    },
    {
      path: '/financeiro',
      meta: {
        breadcrumb: 'Financeiro',
        publicPage: true,
      },
      component: { render: h => h('router-view') },
      children: [
        {
          path: '',
          name: 'financeiro',
          meta: {
            publicPage: true,
          },
          component: () =>
            import(/* webpackChunkName: "financeiro" */ './views/financeiro/index.vue'),
        },
        {
          path: 'certidao-negativa/validar',
          name: 'certidao-negativa-validar',
          meta: {
            publicPage: true,
          },
          component: () =>
            import(
              /* webpackChunkName: "financeiro" */ './views/financeiro/certidao-negativa/validar/index.vue'
            ),
        },
        {
          path: 'certidao-negativa/gerar',
          name: 'certidao-negativa-gerar',
          meta: {
            publicPage: true,
          },
          component: () =>
            import(
              /* webpackChunkName: "financeiro" */ './views/financeiro/certidao-negativa/gerar/index.vue'
            ),
        },
      ],
    },
    {
      path: '/transportes',
      meta: {
        breadcrumb: 'Transportes',
        publicPage: true,
      },
      component: { render: h => h('router-view') },
      children: [
        {
          path: '',
          name: 'transportes',
          meta: {
            publicPage: true,
          },
          component: () =>
            import(/* webpackChunkName: "transportes" */ './views/transportes/Transportes.vue'),
        },
        {
          path: 'passe-livre',
          meta: {
            breadcrumb: 'Passe Livre',
            publicPage: true,
          },
          component: () =>
            import(
              /* webpackChunkName: "passe-livre" */ './views/transportes/passe-livre/Home.vue'
            ),
          children: [
            {
              path: '',
              meta: {
                publicPage: true,
              },
              name: 'passe-livre',
              component: () =>
                import(
                  /* webpackChunkName: "passe-livre-login" */ './views/transportes/passe-livre/Login.vue'
                ),
            },
            {
              path: ':id/detalhe',
              meta: {
                breadcrumb: 'Detalhes',
                publicPage: false,
              },
              name: 'passe-livre-detalhe',
              component: () =>
                import(
                  /* webpackChunkName: "passe-livre-detalhe" */ './views/transportes/passe-livre/Detalhe.vue'
                ),
            },
            {
              path: ':id/detalhe/:processo/editar',
              meta: {
                breadcrumb: 'Editar Cadastro',
                publicPage: false,
              },
              beforeEnter: hasInclusionAndFinishedRegister,
              name: 'passe-livre-edit-cadastro',
              component: () =>
                import(
                  /* webpackChunkName: "passe-livre-detalhe" */ './views/transportes/passe-livre/Cadastro.vue'
                ),
            },
            {
              path: ':id/detalhe/:processo/confirmar',
              meta: {
                breadcrumb: 'Confirmar Cadastro',
                publicPage: false,
              },
              beforeEnter: hasInclusionAndFinishedRegister,
              name: 'passe-livre-confirmar-cadastro',
              component: () =>
                import(
                  /* webpackChunkName: "passe-livre-detalhe" */ './views/transportes/passe-livre/Confirmar.vue'
                ),
            },
            {
              path: 'cadastro',
              meta: {
                breadcrumb: 'Cadastro',
                publicPage: true,
              },
              name: 'passe-livre-cadastro',
              beforeEnter: canRegister,
              component: () =>
                import(
                  /* webpackChunkName: "passe-livre-cadastro" */ './views/transportes/passe-livre/Cadastro.vue'
                ),
            },
          ],
        },
        {
          path: 'login',
          name: 'login-transportes',
          meta: {
            breadcrumb: 'Login Transportes',
            publicPage: true,
          },
          component: () =>
            import(/* webpackChunkName: "licenca-especial" */ './views/transportes/Login.vue'),
        },
        {
          path: 'servicos',
          name: 'servicos',
          meta: {
            breadcrumb: 'Serviços',
            publicPage: false,
          },
          component: { render: h => h('router-view') },
          children: [
            // component: () =>
            //   import(
            //     /* webpackChunkName: "licenca-especial" */ "./views/transportes/servicos/index.vue"
            //     ),
            {
              path: '',
              name: 'servicos-transportes',
              meta: {
                publicPage: false,
              },
              component: () =>
                import(
                  /* webpackChunkName: "licenca-especial" */ './views/transportes/servicos/index.vue'
                ),
            },
            {
              path: 'politica-privacidade',
              name: 'politica-privacidade',
              meta: {
                breadcrumb: 'Política de Privacidade',
                publicPage: true,
                noHeader: true,
              },
              component: () =>
                import(
                  /* webpackChunkName: "politica-privacidade" */ './views/transportes/servicos/PoliticaPrivacidade.vue'
                ),
            },
            {
              path: 'parcelamento',
              name: 'parcelamento',
              meta: {
                breadcrumb: 'Parcelamento',
                publicPage: false,
              },
              component: () =>
                import(
                  /* webpackChunkName: "politica-privacidade" */ './views/transportes/servicos/parcelamento/Parcelamento.vue'
                ),
            },
            {
              path: "taxas-regulacao",
              name: "taxas-regulacao",
              meta: {
                breadcrumb: "Taxas de Regulação",
                publicPage: false,
              },
              component: () =>
                import(
                  /* webpackChunkName: "taxas-regulacao" */ "./views/transportes/servicos/taxas-regulacao/Home.vue"
                ),
            },
            {
              path: "consulta-de-pendencias",
              name: "consulta-de-pendencias",
              meta: {
                breadcrumb: 'Consulta de Pendências',
                publicPage: false,
              },
              component: () =>
                import(
                  /* webpackChunkName: "consulta-pendencias" */ './views/transportes/consulta-pendencias/Home.vue'
                ),
            },
            {
              path: 'taxa-de-regulacao',
              name: 'taxa-de-regulacao',
              meta: {
                breadcrumb: 'Taxa de Regulação',
                publicPage: false,
              },
              component: () =>
                import(
                  /* webpackChunkName: "taxa-de-regulacao" */ './views/transportes/taxa-regulacao/Home.vue'
                ),
            },
            {
              path: 'licenca-especial',
              meta: {
                breadcrumb: 'Licença Especial',
                publicPage: false,
              },
              children: [
                {
                  path: '/',
                  name: 'licenca-especial',
                  meta: {
                    publicPage: false,
                  },
                  component: () =>
                    import(
                      /* webpackChunkName: "licenca-especial" */ './views/transportes/licenca-especial/LicencaEspecial.vue'
                    ),
                },
                {
                  path: 'veiculos/:veiculoId',
                  component: () =>
                    import(
                      /* webpackChunkName: "licenca-especial" */ './views/transportes/licenca-especial/veiculo/Home.vue'
                    ),
                  children: [
                    {
                      path: '',
                      meta: {
                        breadcrumb: 'Veículo',
                        publicPage: false,
                      },
                      component: () =>
                        import(
                          /* webpackChunkName: "licenca-especial" */ './views/transportes/licenca-especial/veiculo/VeiculoIndex.vue'
                        ),
                      children: [
                        {
                          path: '',
                          name: 'licenca-especial-veiculo',
                          component: () =>
                            import(
                              /* webpackChunkName: "licenca-especial" */ './views/transportes/licenca-especial/veiculo/Veiculo.vue'
                            ),
                        },
                        {
                          path: 'autorizacoes/:autorizacaoId',
                          name: 'licenca-especial-autorizacao',
                          meta: {
                            breadcrumb: 'Autorizações',
                            publicPage: false,
                          },
                          component: () =>
                            import(
                              /* webpackChunkName: "licenca-especial" */ './views/transportes/licenca-especial/autorizacao/Autorizacao.vue'
                            ),
                        },
                      ],
                    },
                  ],
                },
              ],
              component: () =>
                import(
                  /* webpackChunkName: "licenca-especial" */ './views/transportes/licenca-especial/Home.vue'
                ),
            },
            {
              path: 'taxas-avulsas',
              name: 'taxas-avulsas',
              meta: {
                breadcrumb: 'Taxas Avulsas',
                publicPage: false,
              },
              component: () =>
                import(
                  /* webpackChunkName: "infracoes-taxas" */ './views/transportes/taxas-avulsas/Home.vue'
                ),
            },
            {
              path: 'certificado-inclusao-de-veiculo',
              name: 'certificado-inclusao-de-veiculo',
              meta: {
                breadcrumb: 'Certificado de Inclusão de Veículo',
                publicPage: false,
              },
              component: () =>
                import(
                  /* webpackChunkName: "certificado-inclusao-de-veiculo" */ './views/transportes/certificados/InclusaoVeiculo.vue'
                ),
            },
            {
              path: 'certificado-de-registro',
              name: 'certificado-de-registro',
              meta: {
                breadcrumb: 'Certificado de Registro',
                publicPage: false,
              },
              component: () =>
                import(
                  /* webpackChunkName: "certificado-de-registro" */ './views/transportes/certificados/RegistroArce.vue'
                ),
            },
            {
              path: 'extrato-de-infracao',
              meta: {
                breadcrumb: 'Extrato de Infração',
                publicPage: false,
              },
              children: [
                {
                  path: '/',
                  name: 'extrato-de-infracao',
                  component: () =>
                    import(
                      /* webpackChunkName: "infracoes-taxas" */ './views/transportes/extrato-infracao/Home.vue'
                    ),
                },
              ],
              component: () =>
                import(
                  /* webpackChunkName: "infracoes-taxas" */ './views/transportes/extrato-infracao/ExtratoInfracao.vue'
                ),
            },
            {
              path: 'consulta-pendencias',
              meta: {
                breadcrumb: 'Consulta Pendências',
                publicPage: true,
              },
              component: () =>
                import(
                  /* webpackChunkName: "consulta-pendencias" */ './views/transportes/ConsultaPendencias.vue'
                ),
            },
            {
              path: 'relatorio-frota-veiculo',
              name: 'relatorio-frota-veiculo',
              meta: {
                breadcrumb: 'Relatório de Frota Veículo',
                publicPage: false,
              },
              component: () =>
                import(
                  /* webpackChunkName: "relatorio-frota-veiculo" */ './views/transportes/relatorio-frota/Veiculo.vue'
                ),
            },
            {
              path: 'notificacao-de-infracao',
              name: 'notificacao-de-infracao',
              meta: {
                breadcrumb: 'Notificação de Infração',
                publicPage: false,
              },
              component: () =>
                import(
                  /* webpackChunkName: "infracoes-taxas" */ './views/transportes/auto-infracao/Home.vue'
                ),
            },
            {
              path: 'relatorio-frota-auto-infracao',
              name: 'relatorio-frota-auto-infracao',
              meta: {
                breadcrumb: 'Relatório de Frota Auto de Infração',
                publicPage: false,
              },
              component: () =>
                import(
                  /* webpackChunkName: "relatorio-frota-auto-infracao" */ './views/transportes/relatorio-frota/AutoInfracao.vue'
                ),
            },
            {
              path: 'pedidos',
              name: 'pedidos',
              meta: {
                breadcrumb: 'Pedidos',
                publicPage: false,
              },
              component: () =>
                import(
                  /* webpackChunkName: "sit-pedidos" */ './views/transportes/sit-pedidos/index.vue'
                ),
              children: [
                {
                  path: 'renovacao-registro-veiculo',
                  name: 'renovacao-registro-veiculo',
                  meta: {
                    breadcrumb: 'Renovação do Registro de Veículo',
                    publicPage: false,
                  },
                  component: () =>
                    import(
                      /* webpackChunkName: "renovacao-registro-veiculo" */ './views/transportes/sit-pedidos/renovacao-veiculo/index.vue'
                    ),
                },
                {
                  path: 'inclusao-veiculo',
                  name: 'inclusao-veiculo',
                  meta: {
                    breadcrumb: 'Inclusão de Veículo',
                    publicPage: false,
                  },
                  component: () =>
                    import(
                      /* webpackChunkName: "inclusao-veiculo" */ './views/transportes/sit-pedidos/inclusao-veiculo/index.vue'
                    ),
                },
                {
                  path: 'exclusao-veiculo',
                  name: 'exclusao-veiculo',
                  meta: {
                    breadcrumb: 'Exclusão de Veículo',
                    publicPage: false,
                  },
                  component: () =>
                    import(
                      /* webpackChunkName: "exclusao-veiculo" */ './views/transportes/sit-pedidos/exclusao-veiculo/index.vue'
                    ),
                },
                {
                  path: 'renovacao-transportadora',
                  name: 'renovacao-transportadora',
                  meta: {
                    breadcrumb: 'Renovação Transportadora',
                    publicPage: false,
                  },
                  component: () =>
                    import(
                      /* webpackChunkName: "renovacao-transportadora" */ './views/transportes/sit-pedidos/renovacao-transportadora/index.vue'
                    ),
                },
                {
                  path: 'substituicao-cooperado',
                  name: 'substituicao-cooperado',
                  meta: {
                    breadcrumb: 'Substituição de Cooperado',
                    publicPage: false,
                  },
                  component: () =>
                    import(
                      /* webpackChunkName: "substituicao-cooperado" */ './views/transportes/sit-pedidos/substituicao-cooperado/index.vue'
                    ),
                },
                {
                  path: '',
                  name: 'pedidos-list',
                  meta: {
                    publicPage: false,
                  },
                  component: () =>
                    import(
                      /* webpackChunkName: "sit-pedidos" */ './views/transportes/sit-pedidos/pedidos/List.vue'
                    ),
                },
                {
                  path: ':id',
                  name: 'pedidos-detail',
                  meta: {
                    breadcrumb: 'Detalhe',
                    publicPage: false,
                  },
                  component: () =>
                    import(
                      /* webpackChunkName: "sit-pedidos" */ './views/transportes/sit-pedidos/pedidos/Detail.vue'
                    ),
                },
              ],
            },
          ],
        },
        {
          path: 'cadastro-transportadora',
          name: 'cadastro-transportadora',
          meta: {
            breadcrumb: 'Cadastro Transportadora',
            publicPage: false,
          },
          component: () =>
            import(
              /* webpackChunkName: "cadastro-transportadora" */ './views/transportes/sit-pedidos/cadastro-transportadora/index.vue'
            ),
        },
        {
          path: 'resetar-token',
          name: 'resetar-token',
          meta: {
            publicPage: true,
          },
          component: () =>
            import(/* webpackChunkName: "transportes" */ './views/transportes/ResetToken.vue'),
        },
        {
          path: 'validacao-de-certificado',
          name: 'validacao-de-certificado',
          meta: {
            breadcrumb: 'Certificado de Registro',
            publicPage: false,
          },
          component: () =>
            import(
              /* webpackChunkName: "validacao-de-certificado" */ './views/transportes/certificados/ValidacaoCertificado.vue'
            ),
        },
        {
          path: 'detalhe-certificado/:codigoValidador',
          name: 'detalhe-certificado',
          meta: {
            breadcrumb: 'Detalhe Certificado',
            publicPage: true,
          },
          component: () =>
            import(
              /* webpackChunkName: "detalhe-certificado" */ './views/transportes/certificados/DetalheCertificado.vue'
            ),
        },
        {
          path: 'linhas-regulares',
          name: 'linhas-regulares',
          meta: {
            breadcrumb: 'Linhas Regulares de Passageiros',
            publicPage: true,
          },
          component: () =>
            import(
              /* webpackChunkName: "linhas-regulares" */ './views/transportes/linhas-regulares/LinhasRegulares.vue'
            ),
        },
        {
          path: 'carteira-macro-regiao',
          name: 'carteira-macro-regiao',
          meta: {
            breadcrumb: 'Carteira Macro Região',
            publicPage: true,
          },
          component: () =>
            import(
              /* webpackChunkName: "carteira-macro-regiao" */ './views/transportes/carteira-macro-regiao/Login.vue'
            ),
        },
        {
          path: 'rota-emocoes',
          name: 'rota-emocoes',
          meta: {
            breadcrumb: 'Rota das Emoções',
            publicPage: true,
          },
          component: () =>
            import(
              /* webpackChunkName: "rota-emocoes" */ './views/transportes/rota-emocoes/RotaEmocoes.vue'
            ),
        },
        {
          path: 'consulta-transportadoras-regularizadas',
          name: 'consulta-transportadoras-regularizadas',
          meta: {
            breadcrumb: 'Consulta Transportadoras Regularizadas',
            publicPage: true,
          },
          component: () =>
            import(
              /* webpackChunkName: "rota-emocoes" */ './views/transportes/consulta-transportadoras-regularizadas/index.vue'
            ),
        },
        // {
        //   path: "pedidos",
        //   meta: {
        //     breadcrumb: "Pedidos",
        //     publicPage: false,
        //   },
        //   component: () =>
        //     import(
        //       /* webpackChunkName: "sit-pedidos" */ "./views/transportes/sit-pedidos/index.vue"
        //     ),
        //   children: [
        //     {
        //       path: "",
        //       meta: {
        //         authorize: [],
        //         publicPage: false,
        //       },
        //       component: { render: (h) => h("router-view") },
        //       children: [,],
        //     },
        //   ],
        // },

        {
          path: 'financeiro',
          name: 'login-parcelamento',
          meta: {
            breadcrumb: 'Login',
            publicPage: false,
          },
          component: () =>
            import(
              /* webpackChunkName: "relatorio-frota-auto-infracao" */ './views/transportes/financeiro/index.vue'
            ),
        },
      ],
    },
    {
      path: '/vaivem',
      meta: {
        breadcrumb: 'VaiVem',
        publicPage: false,
      },
      component: { render: h => h('router-view') },
      children: [
        {
          path: '',
          name: 'vaivem',
          meta: {
            publicPage: true,
          },
          component: () =>
            import(/* webpackChunkName: "transportes" */ './views/transportes/vai-vem/Menu.vue'),
        },
        {
          path: 'consulta-cpf',
          name: 'vai-vem-aluno',
          meta: {
            breadcrumb: 'Consulta CPF',
            publicPage: true,
          },
          component: () =>
            import(
              /* webpackChunkName: "vai-vem" */ './views/transportes/vai-vem/aluno/Consulta.vue'
            ),
        },
        {
          path: 'confirmar-entrega',
          name: 'confirmar-entrega',
          meta: {
            breadcrumb: 'Confirmação de entrega',
            publicPage: false,
          },
          component: { render: h => h('router-view') },
          children: [
            {
              path: '',
              name: 'confirmar-entrega',
              meta: {
                breadcrumb: 'Menu',
                publicPage: false,
              },
              component: () =>
                import(
                  /* webpackChunkName: "vai-vem" */ './views/transportes/vai-vem/sindionibus/Menu.vue'
                ),
            },
            {
              path: 'trabalhador',
              name: 'trabalhador',
              meta: {
                breadcrumb: 'Trabalhador',
                publicPage: true,
              },
              component: { render: h => h('router-view') },
              children: [
                {
                  path: 'login',
                  name: 'login-trabalhador',
                  meta: {
                    breadcrumb: 'Login',
                    publicPage: true,
                  },
                  component: () =>
                    import(
                      /* webpackChunkName: "vai-vem" */ './views/transportes/vai-vem/sindionibus/Login.vue'
                    ),
                },
                {
                  path: '',
                  name: 'trabalhador',
                  meta: {
                    breadcrumb: 'Confirmação',
                    publicPage: false,
                    authorize: ['central_vaivem_desempregado'],
                  },
                  component: () =>
                    import(
                      /* webpackChunkName: "vai-vem" */ './views/transportes/vai-vem/sindionibus/ConfirmaEntregaDesempregado.vue'
                    ),
                },
              ],
            },
            {
              path: 'estudante',
              name: 'estudante',
              meta: { breadcrumb: 'Estudante', publicPage: true },
              redirect: { name: 'login-estudante' },
              component: { render: h => h('router-view') },
              children: [
                {
                  path: 'login',
                  name: 'login-estudante',
                  meta: { breadcrumb: 'Login', publicPage: true },
                  component: () =>
                    import(
                      /* webpackChunkName: "vai-vem" */ './views/transportes/vai-vem/sindionibus/Login.vue'
                    ),
                },
                {
                  path: 'confirma',
                  name: 'estudante-confirma',
                  meta: {
                    breadcrumb: 'Confirmação',
                    publicPage: false,
                    authorize: ['central_vaivem_estudante'],
                  },
                  component: () =>
                    import(
                      /* webpackChunkName: "vai-vem" */ './views/transportes/vai-vem/sindionibus/ConfirmaEntrega.vue'
                    ),
                },
              ],
            },
          ],
        },
      ],
    },
    {
      path: '/ouvidoria',
      meta: {
        breadcrumb: 'Ouvidoria',
        publicPage: true,
      },
      component: { render: h => h('router-view') },
      children: [
        {
          path: '',
          meta: {
            publicPage: true,
          },
          component: () =>
            import(/* webpackChunkName: "ouvidoria" */ './views/ouvidoria/Ouvidoria.vue'),
        },
        // {
        //   path: "solicitacao",
        //   name: "solicitacao",
        //   meta: {
        //     breadcrumb: "Solicitação",
        //     publicPage: true
        //   },
        //   component: () =>
        //     import(
        //       /* webpackChunkName: "solicitacao" */ "./views/ouvidoria/solicitacao/Home.vue"
        //       )
        // },
        {
          path: 'acompanhar-solicitacao',
          name: 'acompanhar-solicitacao',
          meta: {
            breadcrumb: 'Acompanhar Solicitação',
            publicPage: true,
          },
          component: () =>
            import(
              /* webpackChunkName: "solicitacao" */ './views/ouvidoria/solicitacao/Acompanhar.vue'
            ),
        },
        {
          path: 'painel-da-ouvidoria',
          name: 'painel-da-ouvidoria',
          meta: {
            breadcrumb: 'Painel da Ouvidoria',
            publicPage: true,
          },
          component: () =>
            import(/* webpackChunkName: "solicitacao" */ './views/ouvidoria/PainelOuvidoria.vue'),
        },
        {
          path: 'fale-com-presidente',
          name: 'fale-com-presidente',
          meta: {
            breadcrumb: 'Fale com o Presidente',
            publicPage: true,
          },
          component: () =>
            import(
              /* webpackChunkName: "fale-presidente" */ './views/ouvidoria/FalePresidente.vue'
            ),
        },
      ],
    },
    {
      path: '/processos',
      meta: {
        breadcrumb: 'Processos',
        publicPage: true,
      },
      component: { render: h => h('router-view') },
      children: [
        {
          path: '/',
          meta: {
            publicPage: true,
          },
          component: () =>
            import(/* webpackChunkName: "processos" */ './views/documentos/Documentos.vue'),
        },
        {
          path: 'consultar-processos-ate-2020',
          name: 'consultar-processos-ate-2020',
          meta: {
            breadcrumb: 'Consultar Processos até 2020',
            publicPage: true,
          },
          component: () =>
            import(
              /* webpackChunkName: "consultar-processos-ate-2020" */ './views/documentos/ConsultaProcessos.vue'
            ),
        },
        {
          path: 'consultar-processos-entre-2021-e-2023',
          name: 'consultar-processos-entre-2021-e-2023',
          meta: {
            breadcrumb: 'Consultar Processos entre 2021 e 2023',
            publicPage: true,
          },
          component: () =>
            import(
              /* webpackChunkName: "consultar-processos-entre-2021-e-2023" */ './views/processo/ConsultaProcessos.vue'
            ),
        },
        {
          path: 'consultar-processos-a-partir-de-2024',
          name: 'consultar-processos-a-partir-de-2024',
          meta: {
            breadcrumb: 'Consultar Processos a partir de 2024',
            publicPage: true,
          },
          component: () =>
            import(
              /* webpackChunkName: "consultar-processos-a-partir-de-2024" */ './views/processo/ConsultaProcessoSuite2024.vue'
            ),
        },
        {
          path: 'relatorio-de-julgamento-ate-2023',
          name: 'relatorio-de-julgamento-ate-2023',
          meta: {
            breadcrumb: 'Relatório de Julgamento até 2023',
            publicPage: true,
          },
          component: () =>
            import(
              /* webpackChunkName: "relatorio-de-julgamento-ate-2023" */ './views/documentos/RelatorioJulgamento.vue'
            ),
        },
        {
          path: 'relatorio-de-julgamento-a-partir-2024',
          name: 'relatorio-de-julgamento-a-partir-2024',
          meta: {
            breadcrumb: 'Relatório de Julgamento a partir de 2024',
            publicPage: true,
          },
          component: () =>
            import(
              /* webpackChunkName: "relatorio-de-julgamento-a-partir-2024" */ './views/documentos/RelatorioJulgamento2024.vue'
            ),
        },
        {
          path: 'notificacao-de-penalidade-ate-2023',
          name: 'notificacao-de-penalidade-ate-2023',
          meta: {
            breadcrumb: 'Notificação de Penalidade até 2023',
            publicPage: true,
          },
          component: () =>
            import(
              /* webpackChunkName: "notificacao-de-penalidade-a-partir-de-2024" */ './views/documentos/NotificacaoPenalidade.vue'
            ),
        },
        {
          path: 'notificacao-de-penalidade-a-partir-de-2024',
          name: 'notificacao-de-penalidade-a-partir-de-2024',
          meta: {
            breadcrumb: 'Notificação de Penalidade a partir de 2024',
            publicPage: true,
          },
          component: () =>
            import(
              /* webpackChunkName: "notificacao-de-penalidade-a-partir-de-2024" */ './views/documentos/NotificacaoPenalidade2024.vue'
            ),
        },
        {
          path: 'nji-dae',
          name: 'nji-dae',
          meta: {
            breadcrumb: 'NJI DAE',
            publicPage: false,
          },
          component: () =>
            import(
              /* webpackChunkName: "notificacao-de-penalidade" */ './views/documentos/Dae.vue'
            ),
        },
      ],
    },
    {
      path: '/ceara-app/fale-com-presidente',
      name: 'ceara-app-fale-com-presidente',
      meta: {
        breadcrumb: 'Fale com o Presidente',
        publicPage: true,
        cearaApp: true,
      },
      component: () =>
        import(/* webpackChunkName: "fale-presidente" */ './views/ouvidoria/FalePresidente.vue'),
    },
    {
      path: '/ceara-app/solicitacao',
      name: 'ceara-app-solicitacao',
      meta: {
        breadcrumb: 'Solicitação',
        publicPage: true,
        cearaApp: true,
      },
      component: () =>
        import(/* webpackChunkName: "solicitacao" */ './views/ouvidoria/solicitacao/Home.vue'),
    },
    {
      path: '/ceara-app/acompanhar-solicitacao',
      name: 'ceara-app-acompanhar-solicitacao',
      meta: {
        breadcrumb: 'Acompanhar Solicitação',
        publicPage: true,
        cearaApp: true,
      },
      component: () =>
        import(
          /* webpackChunkName: "solicitacao" */ './views/ouvidoria/solicitacao/Acompanhar.vue'
        ),
    },
    {
      path: '/ceara-app/consulta-de-processos',
      name: 'ceara-app-consulta-de-processo',
      meta: {
        breadcrumb: 'Consulta de Processos',
        publicPage: true,
        cearaApp: true,
      },
      component: () =>
        import(
          /* webpackChunkName: "consulta-de-processos" */ './views/documentos/ConsultaProcessos.vue'
        ),
    },
    {
      path: '/ceara-app/passe-livre',
      meta: {
        breadcrumb: 'Passe Livre',
        publicPage: true,
        cearaApp: true,
      },
      component: () =>
        import(/* webpackChunkName: "passe-livre" */ './views/cearaApp/passe-livre/Home.vue'),
      children: [
        {
          path: '',
          meta: {
            publicPage: true,
            cearaApp: true,
          },
          name: 'ceara-app-passe-livre',
          component: () =>
            import(
              /* webpackChunkName: "passe-livre-login" */ './views/cearaApp/passe-livre/Login.vue'
            ),
        },
        {
          path: ':id/detalhe',
          meta: {
            breadcrumb: 'Detalhes',
            publicPage: false,
            cearaApp: true,
          },
          name: 'ceara-app-passe-livre-detalhe',
          component: () =>
            import(
              /* webpackChunkName: "passe-livre-detalhe" */ './views/cearaApp/passe-livre/Detalhe.vue'
            ),
        },
        {
          path: ':id/detalhe/:processo/editar',
          meta: {
            breadcrumb: 'Editar Cadastro',
            publicPage: false,
            cearaApp: true,
          },
          beforeEnter: hasInclusionAndFinishedRegisterCearaApp,
          name: 'ceara-app-passe-livre-edit-cadastro',
          component: () =>
            import(
              /* webpackChunkName: "passe-livre-detalhe" */ './views/cearaApp/passe-livre/Cadastro.vue'
            ),
        },
        {
          path: ':id/detalhe/:processo/confirmar',
          meta: {
            breadcrumb: 'Confirmar Cadastro',
            publicPage: false,
            cearaApp: true,
          },
          beforeEnter: hasInclusionAndFinishedRegisterCearaApp,
          name: 'ceara-app-passe-livre-confirmar-cadastro',
          component: () =>
            import(
              /* webpackChunkName: "passe-livre-detalhe" */ './views/cearaApp/passe-livre/Confirmar.vue'
            ),
        },
        {
          path: 'cadastro',
          meta: {
            breadcrumb: 'Cadastro',
            publicPage: true,
            cearaApp: true,
          },
          name: 'ceara-app-passe-livre-cadastro',
          beforeEnter: canRegisterCearaApp,
          component: () =>
            import(
              /* webpackChunkName: "passe-livre-cadastro" */ './views/cearaApp/passe-livre/Cadastro.vue'
            ),
        },
      ],
    },
    {
      path: '*',
      meta: { publicPage: true, breadcrumb: '404' },
      redirect: {
        path: '/404',
      },
    },
    {
      path: '/404',
      name: 'not-found',
      meta: { publicPage: true, breadcrumb: '404' },
      component: () => import(/* webpackChunkName: "notFound" */ './views/NotFound.vue'),
    },
    {
      path: '/403',
      meta: { publicPage: true },
      name: 'denied',
      component: () => import(/* webpackChunkName: "accessDenied" */ `@/views/Deny.vue`),
    },
    {
      path: '/carteira-macrorregiao',
      meta: {
        breadcrumb: 'Carteira Macrorregião',
        publicPage: false,
      },
      component: { render: h => h('router-view') },
      children: [
        {
          path: '',
          name: 'sie',
          meta: {
            publicPage: false,
          },
          component: () =>
            import(
              /* webpackChunkName: "transportes" */ '@/views/transportes/sie-pedidos/index.vue'
            ),
        },
        {
          path: 'aluno',
          name: 'aluno',
          meta: {
            breadcrumb: 'Aluno',
            publicPage: false,
          },
          component: { render: h => h('router-view') },
          children: [
            {
              path: '',
              name: 'aluno-consulta',
              meta: {
                breadcrumb: 'Consulta de Solicitação',
                publicPage: true,
              },
              component: () =>
                import(
                  /* webpackChunkName: "sit-pedidos" */ './views/transportes/sie-pedidos/Aluno/FormConsultaCPF.vue'
                ),
            },
            {
              path: 'aluno-solicitacao',
              name: 'aluno-solicitacao',
              meta: {
                breadcrumb: 'Situação da Solicitação',
                publicPage: true,
              },
              component: () =>
                import(
                  /* webpackChunkName: "sit-pedidos" */ './views/transportes/sie-pedidos/Aluno/ModalSolicitacaoAluno.vue'
                ),
            },
          ],
        },
        {
          path: 'login-entidade',
          name: 'login-entidade',
          meta: {
            breadcrumb: 'Login Entidade',
            publicPage: true,
          },
          component: () =>
            import(
              /* webpackChunkName: "sit-pedidos" */ './views/transportes/sie-pedidos/communs/Login.vue'
            ),
        },
        {
          path: 'recuperar-senha-entidade',
          name: 'recuperar-senha-entidade',
          meta: {
            breadcrumb: 'Recuperar Senha',
            publicPage: true,
          },
          component: () => import('./views/transportes/sie-pedidos/communs/RecuperarSenha.vue'),
        },
        {
          path: 'entidade',
          name: 'entidade',
          meta: {
            breadcrumb: 'Entidade',
            publicPage: true,
          },
          redirect: '/carteira-macrorregiao/entidade/criar-solicitacao',
          component: () =>
            import(
              /* webpackChunkName: "sit-pedidos" */ './views/transportes/sie-pedidos/Entidade/index.vue'
            ),
          children: [
            {
              path: '',
              meta: {
                authorize: ['central-servicos-sie-entidade'],
                publicPage: false,
              },
              redirect: '/carteira-macrorregiao/entidade/criar-solicitacao',
              component: { render: h => h('router-view') },
              children: [
                {
                  path: 'criar-solicitacao',
                  name: 'criar-solicitacao',
                  meta: {
                    breadcrumb: 'Consultar CPF',
                    publicPage: false,
                    authorize: ['central-servicos-sie-entidade'],
                  },
                  component: () =>
                    import('./views/transportes/sie-pedidos/Entidade/Solicitacao/ConsultaCpf.vue'),
                },
                {
                  path: 'solicitacoes',
                  name: 'solicitacoes',
                  meta: {
                    breadcrumb: 'Solicitações',
                    publicPage: false,
                  },
                  component: { render: h => h('router-view') },
                  children: [
                    {
                      path: '',
                      name: 'solicitacoes',
                      meta: {
                        breadcrumb: 'Lista de Solicitações',
                        publicPage: false,
                      },
                      component: () => import('./views/transportes/sie-pedidos/Entidade/List.vue'),
                    },
                    {
                      path: 'detalhamento/:id',
                      name: 'detalhamento',
                      meta: {
                        breadcrumb: 'Detalhamento da Solicitação',
                        authorize: ['central-servicos-sie-entidade'],
                      },
                      component: () =>
                        import('./views/transportes/sie-pedidos/Entidade/Detalhamento.vue'),
                    },
                  ],
                },
                {
                  path: 'lotes',
                  name: 'lotes',
                  meta: {
                    breadcrumb: 'Consultar CPF',
                    publicPage: false,
                    authorize: ['central-servicos-sie-entidade'],
                  },
                  component: { render: h => h('router-view') },
                  children: [
                    {
                      path: '',
                      name: 'lotes',
                      meta: {
                        breadcrumb: 'Lista de Lotes',
                        publicPage: false,
                        authorize: ['central-servicos-sie-entidade'],
                      },
                      component: () =>
                        import('./views/transportes/sie-pedidos/Entidade/Lote/ListaLotes.vue'),
                    },
                    {
                      path: 'historico/:id',
                      name: 'historico-lote',
                      meta: {
                        breadcrumb: 'Histórico do Lote',
                        publicPage: false,
                        authorize: ['central-servicos-sie-entidade'],
                      },
                      component: () =>
                        import('./views/transportes/sie-pedidos/Entidade/Lote/Historico.vue'),
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          path: 'login-grafica',
          name: 'login-grafica',
          meta: {
            publicPage: true,
            breadcrumb: 'Login Gráfica',
          },
          component: () =>
            import(
              /* webpackChunkName: "sit-pedidos" */ './views/transportes/sie-pedidos/communs/Login.vue'
            ),
        },
        {
          path: 'recuperar-senha-grafica',
          name: 'recuperar-senha-grafica',
          meta: {
            breadcrumb: 'Recuperar Senha',
            authorize: ['central-servicos-sie-grafica'],
            publicPage: false,
          },
          component: () => import('./views/transportes/sie-pedidos/communs/RecuperarSenha.vue'),
        },
        {
          path: 'grafica',
          name: 'grafica',
          meta: {
            breadcrumb: 'Gráfica',
            publicPage: false,
            authorize: ['central-servicos-sie-grafica'],
          },
          redirect: '/carteira-macrorregiao/grafica/lote',
          component: { render: h => h('router-view') },
          children: [
            {
              path: 'lote',
              name: 'lote',
              meta: {
                breadcrumb: 'Lista de Lotes',
                publicPage: false,
              },
              component: () =>
                import(
                  /* webpackChunkName: "sit-pedidos" */ './views/transportes/sie-pedidos/Grafica/index.vue'
                ),
            },
          ],
        },
      ],
    },
    {
      path: '/saneamento/login',
      name: '/saneamento/login',
      meta: {
        breadcrumb: 'Login',
        publicPage: true,
      },
      component: () => import(/* webpackChunkName: "transportes" */ '@/views/gessan/Login.vue'),
    },
    {
      path: '/saneamento',
      meta: {
        breadcrumb: 'Saneamento',
        publicPage: false,
      },
      component: () =>
        import(/* webpackChunkName: "transportes" */ '@/views/gessan/Saneamento/index.vue'),
      children: [
        {
          path: '',
          name: 'saneamento-home',
          meta: {
            breadcrumb: 'Saneamento',
            publicPage: false,
          },
          component: () =>
            import(/* webpackChunkName: "transportes" */ '@/views/gessan/Saneamento/Home.vue'),
        },
        {
          path: 'informe-repasse-regulacao',
          name: 'informe-repasse-regulacao',
          meta: {
            breadcrumb: 'Informar Repasse de Regulação',
            publicPage: false,
          },
          component: () =>
            import(/* webpackChunkName: "transportes" */ '@/views/gessan/Saneamento/Cadastro.vue'),
        },
        {
          path: 'listagem-remuneracoes-regulatorias',
          name: 'listagem-remuneracoes-regulatorias',
          meta: {
            breadcrumb: 'Listagem das Remunerações Regulatórias',
            publicPage: false,
          },
          component: () =>
            import(/* webpackChunkName: "transportes" */ '@/views/gessan/Saneamento/Lista.vue'),
        },
        {
          path: 'multas-administrativas',
          name: 'multas-administrativas',
          meta: {
            breadcrumb: 'Multas Administrativas',
            publicPage: false,
          },
          component: () =>
            import(
              /* webpackChunkName: "transportes" */ '@/views/gessan/Saneamento/MultasAdministrativas.vue'
            ),
        },
        {
          path: 'parcelamento',
          name: 'parcelamento-saneamento',
          meta: {
            breadcrumb: 'Parcelamento',
            publicPage: false,
          },
          component: () =>
            import(
              /* webpackChunkName: "transportes" */ '@/views/gessan/Saneamento/parcelamento/Parcelamento.vue'
            ),
        },
      ],
    },
    {
      path: '/gas-canalizado',
      meta: {
        breadcrumb: 'Gás Canalizado',
        publicPage: true,
      },
      component: { render: h => h('router-view') },
      children: [
        {
          path: '',
          name: 'gas-canalizado',
          meta: {
            breadcrumb: 'Solicitação',
            publicPage: true,
          },
          component: () =>
            import(/* webpackChunkName: "gas-canalizado" */ './views/gas-canalizado/index.vue'),
        },
        {
          path: 'solicitacao',
          name: 'solicitacao',
          meta: {
            breadcrumb: 'Solicitação',
            publicPage: true,
          },
          component: () =>
            import(
              /* webpackChunkName: "gas-canalizado" */ './views/gas-canalizado/spgc/SolicitarAutorizacao.vue'
            ),
        },
        {
          path: 'consultar-solicitacao',
          name: 'consultar-solicitacao',
          meta: {
            breadcrumb: 'Consultar Solicitação',
            publicPage: true,
          },
          component: () =>
            import(
              /* webpackChunkName: "gas-canalizado" */ './views/gas-canalizado/spgc/ConsultarSolicitacao.vue'
            ),
        },

        {
          path: 'autorizacao/validar',
          name: 'autorizacao/validar',
          meta: {
            publicPage: true,
          },
          component: () =>
            import(
              /* webpackChunkName: "gas-canalizado" */ './views/gas-canalizado/spgc/ValidarAutorizacao.vue'
            ),
        },
      ],
    },
    {
      path: '/cpv',
      meta: {
        breadcrumb: 'Cadastro Positivo de Veículos',
      },
      component: { render: h => h('router-view') },
      children: [
        {
          path: 'certidao-veiculo/validar',
          name: 'cpv-certidao-veiculo-validar',
          meta: {
            breadcrumb: 'Validar Certidão Veicular',
            publicPage: true,
          },
          component: () =>
            import('./views/cpv/CertidaoVeiculoValidar.vue'),
        },
        {
          path: '',
          name: 'cpv',
          meta: {
            breadcrumb: 'login',
            publicPage: true,
          },
          component: () =>
            import('./views/cpv/Index.vue'),
        },
        {
          path: '',
          component: () =>
            import('./views/cpv/LayoutCamara.vue'),
          children: [
            {
              path: 'dashboard',
              name: 'cpv-dashboard',
              meta: {
                breadcrumb: 'Dashboard',
              },
              component: () =>
                import('./views/cpv/Dashboard.vue'),
            },

            {
              path: 'vereadores',
              name: 'cpv-vereadores',
              meta: {
                breadcrumb: 'Vereadores',
              },
              component: () =>
                import('./views/cpv/Vereadores.vue'),
            },

            {
              path: 'veiculos',
              name: 'cpv-veiculos',
              meta: {
                breadcrumb: 'Consulta de Veículos',
              },
              component: () =>
                import('./views/cpv/Veiculos.vue'),
            },
            {
              path: 'vereadores/:id',
              name: 'cpv-vereador-detalhes',
              component: () =>
                import('./views/cpv/VereadorDetalhes.vue'),
            }
          ],
        },
      ],
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  },
});


//Proteção do router cpv
function iscpvRoute(routeName?: string, routePath?: string) {
  return (
    (typeof routeName === 'string' &&
      routeName.startsWith('cpv')) ||
    (typeof routePath === 'string' &&
      routePath.startsWith('/cpv'))
  );
}

function hascpvToken() {
  return !!localStorage.getItem('cpv_token');
}

router.beforeEach((to, from, next) => {
  const currentDate = Date.now();

  const currenBbeneficiarioPasseLivre: Beneficiario =
    BeneficiarioAuthService.currentBeneficiarioValue();
  const expireTokenBeneficiario = BeneficiarioAuthService.expireToken();

  const beneficiarioCearaApp = BeneficiarioCearaAppAuthService.currentBeneficiarioValue();
  const beneficiarioCearaAppExpireToken = BeneficiarioCearaAppAuthService.expireToken();

  const currentTransportadora = TransportadoraAuthService.currentTransportadoraValue;

  const expireTokenTransportadora = TransportadoraAuthService.expireToken();

  const expireTokenVaiVemLivre = VaiVemAuthService.expireToken();
  const vaiVemLivre = vaiVemAuthService.currentVaiVemValue;

  const validateEstudante = vaiVemAuthService.validateEstudante();
  const validateDesempregado = vaiVemAuthService.validateDesempregado();

  const entidadeValida: boolean = AuthService.validateEntidade();

  const graficaValida: boolean = AuthService.validateGrafica();

  const experidTokenSie: number = AuthService.expiredToken();

  const protectRoutesGessan = [
    'saneamento-home',
    'informe-repasse-regulacao',
    'listagem-remuneracoes-regulatorias',
    'parcelamento-saneamento',
  ];

  console.log('Rota acessada:', to.name);

  const { name, meta } = to;
  if (iscpvRoute(name, to.path)) {
    if (meta?.publicPage) {
      next();
      return;
    }

    if (!hascpvToken()) {
      next({
        name: 'cpv',
        query: { redirect: to.fullPath }
      });
      return;
    }

    next();
    return;
  }
  if (!meta.publicPage) {
    if (name?.includes('ceara-app-passe-livre')) {
      if (beneficiarioCearaApp) {
        if (currentDate > beneficiarioCearaAppExpireToken) {
          BeneficiarioCearaAppAuthService.logout('warning', 'Sua sessão expirou, faça login novamente.');
        } else {
          next();
        }
      } else {
        GlobalStore.setSnackBar({
          show: true,
          message: 'Você precisa fazer login para acessar.',
          type: 'warning',
          timeout: 4000,
        });
        next({
          name: 'ceara-app-passe-livre',
        });
      }
    } else if (name?.includes('passe-livre')) {
      if (currenBbeneficiarioPasseLivre) {
        if (currentDate > expireTokenBeneficiario) {
          BeneficiarioAuthService.logout('warning', 'Sua sessão expirou, faça login novamente.');
        } else {
          next();
        }
      } else {
        GlobalStore.setSnackBar({
          show: true,
          message: 'Você precisa fazer login para acessar.',
          type: 'warning',
          timeout: 4000,
        });
        next({
          name: 'passe-livre',
        });
      }
    } else if (name?.includes('consulta-de-pendencias')) {
      if (currentTransportadora) {
        if (currentDate > expireTokenTransportadora) {
          TransportadoraAuthService.logout('warning', 'Sua sessão expirou, faça login novamente.');
        } else {
          next();
        }
      } else {
        GlobalStore.setSnackBar({
          show: true,
          message: 'Você precisa fazer login para acessar.',
          type: 'warning',
          timeout: 4000,
        });
        next({
          name: 'login-transportes',
          query: { returnUrl: name },
        });
      }
    } else if (
      name?.includes('servicos-transportes') ||
      name?.includes('taxa-de-regulacao') ||
      name?.includes('renovacao-registro-veiculo') ||
      name?.includes('inclusao-veiculo') ||
      name?.includes('exclusao-veiculo') ||
      name?.includes('renovacao-transportadora') ||
      // name?.includes('cadastro-transportadora') ||
      name?.includes('substituicao-cooperado') ||
      name?.includes('pedidos')
    ) {
      if (currentTransportadora) {
        if (currentDate > expireTokenTransportadora) {
          TransportadoraAuthService.logout('warning', 'Sua sessão expirou, faça login novamente.');
        } else {
          next();
        }
      } else {
        GlobalStore.setSnackBar({
          show: true,
          message: 'Você precisa fazer login para acessar.',
          type: 'warning',
          timeout: 4000,
        });
        next({
          name: 'login-transportes',
          query: { returnUrl: name },
        });
      }
    }  else if (name?.includes('relatorio-frota')) {
      if (currentTransportadora) {
        if (currentDate > expireTokenTransportadora) {
          TransportadoraAuthService.logout('warning', 'Sua sessão expirou, faça login novamente.');
        } else {
          next();
        }
      } else {
        GlobalStore.setSnackBar({
          show: true,
          message: 'Você precisa fazer login para acessar.',
          type: 'warning',
          timeout: 4000,
        });
        next({
          name: 'login-transportes',
          query: { returnUrl: name },
        });
      }
    } else if (name?.includes('licenca-especial')) {
      if (currentTransportadora) {
        if (currentDate > expireTokenTransportadora) {
          TransportadoraAuthService.logout('warning', 'Sua sessão expirou, faça login novamente.');
        } else {
          next();
        }
      } else {
        GlobalStore.setSnackBar({
          show: true,
          message: 'Você precisa fazer login para acessar.',
          type: 'warning',
          timeout: 4000,
        });
        next({
          name: 'login-transportes',
          query: { returnUrl: name },
        });
      }
    } else if (name?.includes('taxas-avulsas')) {
      if (currentTransportadora) {
        if (currentDate > expireTokenTransportadora) {
          TransportadoraAuthService.logout('warning', 'Sua sessão expirou, faça login novamente.');
        } else {
          next();
        }
      } else {
        GlobalStore.setSnackBar({
          show: true,
          message: 'Você precisa fazer login para acessar.',
          type: 'warning',
          timeout: 4000,
        });
        next({
          name: 'login-transportes',
          query: { returnUrl: name },
        });
      }
    } else if (name?.includes('notificacao-de-infracao')) {
      if (currentTransportadora) {
        if (currentDate > expireTokenTransportadora) {
          TransportadoraAuthService.logout('warning', 'Sua sessão expirou, faça login novamente.');
        } else {
          next();
        }
      } else {
        GlobalStore.setSnackBar({
          show: true,
          message: 'Você precisa fazer login para acessar.',
          type: 'warning',
          timeout: 4000,
        });
        next({
          name: 'login-transportes',
          query: { returnUrl: name },
        });
      }
    } else if (name?.includes('certificado-inclusao-de-veiculo')) {
      if (currentTransportadora) {
        if (currentDate > expireTokenTransportadora) {
          TransportadoraAuthService.logout('warning', 'Sua sessão expirou, faça login novamente.');
        } else {
          next();
        }
      } else {
        GlobalStore.setSnackBar({
          show: true,
          message: 'Você precisa fazer login para acessar.',
          type: 'warning',
          timeout: 4000,
        });
        next({
          name: 'login-transportes',
          query: { returnUrl: name },
        });
      }
    } else if (name?.includes('certificado-de-registro')) {
      if (currentTransportadora) {
        if (currentDate > expireTokenTransportadora) {
          TransportadoraAuthService.logout('warning', 'Sua sessão expirou, faça login novamente.');
        } else {
          next();
        }
      } else {
        GlobalStore.setSnackBar({
          show: true,
          message: 'Você precisa fazer login para acessar.',
          type: 'warning',
          timeout: 4000,
        });
        next({
          name: 'login-transportes',
          query: { returnUrl: name },
        });
      }
    } else if (name?.includes('extrato-de-infracao')) {
      if (currentTransportadora) {
        if (currentDate > expireTokenTransportadora) {
          TransportadoraAuthService.logout('warning', 'Sua sessão expirou, faça login novamente.');
        } else {
          next();
        }
      } else {
        GlobalStore.setSnackBar({
          show: true,
          message: 'Você precisa fazer login para acessar.',
          type: 'warning',
          timeout: 4000,
        });
        next({
          name: 'login-transportes',
          query: { returnUrl: name },
        });
      }
    } else if (name?.includes("taxas-regulacao")) {
      if (currentTransportadora) {
        if (currentDate > expireTokenTransportadora) {
          TransportadoraAuthService.logout(
            "warning",
            "Sua sessão expirou, faça login novamente."
          );
        } else {
          next();
        }
      } else {
        GlobalStore.setSnackBar({
          show: true,
          message: "Você precisa fazer login para acessar.",
          type: "warning",
          timeout: 4000,
        });
        next({
          name: "login-transportes",
          query: { returnUrl: name },
        });
      }
    } else if (
      name === 'criar-solicitacao' ||
      name === 'solicitacoes' ||
      name === 'detalhamento' ||
      name === 'lotes' ||
      name === 'historico-lote'
    ) {
      if (entidadeValida) {
        if (currentDate > experidTokenSie) {
          GlobalStore.setSnackBar({
            show: true,
            message: 'Token expirado. Você precisa fazer login para acessar Entidade.',
            type: 'warning',
            timeout: 4000,
          });
          AuthService.logout(true);
        } else {
          next();
        }
      } else {
        GlobalStore.setSnackBar({
          show: true,
          message: 'Você precisa fazer login para acessar Entidade.',
          type: 'warning',
          timeout: 4000,
        });
        next({
          name: 'login-entidade',
        });
      }
    } else if (name === 'lote') {
      if (graficaValida) {
        if (currentDate > experidTokenSie) {
          GlobalStore.setSnackBar({
            show: true,
            message: 'Token expirado. Você precisa fazer login para acessar Gráfica.',
            type: 'warning',
            timeout: 4000,
          });
          AuthService.logout(false);
        } else {
          next();
        }
      } else {
        GlobalStore.setSnackBar({
          show: true,
          message: 'Você precisa fazer login para acessar Gráfica.',
          type: 'warning',
          timeout: 4000,
        });
        next({
          name: 'login-grafica',
        });
      }
    } else if (name === 'estudante') {
      if (validateEstudante) {
        next();
      } else {
        GlobalStore.setSnackBar({
          show: true,
          message: 'Você precisa fazer login para acessar.',
          type: 'warning',
          timeout: 4000,
        });
        next({ name: 'login-estudante' });
      }
    } else if (name === 'trabalhador') {
      if (validateDesempregado) {
        next();
      } else {
        GlobalStore.setSnackBar({
          show: true,
          message: 'Você precisa fazer login para acessar.',
          type: 'warning',
          timeout: 4000,
        });
        next({ name: 'login-trabalhador' });
      }
    } else if (protectRoutesGessan.includes(name) && !authService.currentUserValue) {
      next({ name: '/saneamento/login' });
    } else {
      next();
    }
  } else if (name == '/saneamento/login' && authService.currentUserValue) {
    next({ name: 'saneamento-home' });
  } else if (name === 'login-transportes' && currentTransportadora) {
    GlobalStore.setSnackBar({
      show: true,
      message: 'Você já está logado.',
      type: 'warning',
      timeout: 4000,
    });
    next({
      name: 'licenca-especial',
    });
  } else if (name === 'passe-livre' && currenBbeneficiarioPasseLivre) {
    next({
      name: 'passe-livre-detalhe',
      params: { id: String(currenBbeneficiarioPasseLivre.id) },
    });
  } else if (name === 'ceara-app-passe-livre' && beneficiarioCearaApp) {
    next({
      name: 'ceara-app-passe-livre-detalhe',
      params: { id: String(beneficiarioCearaApp.id) },
    });
  } else if (name == 'login-trabalhador') {
    if (vaiVemLivre) {
      if (currentDate > expireTokenVaiVemLivre) {
        vaiVemAuthService.logout('warning', 'Sua sessão expirou, faça login novamente.', false);
      } else if (validateDesempregado) {
        next({ name: 'trabalhador' });
      } else {
        next();
      }
    } else {
      next();
    }
  } else if (name == 'login-estudante') {
    if (vaiVemLivre) {
      if (currentDate > expireTokenVaiVemLivre) {
        vaiVemAuthService.logout('warning', 'Sua sessão expirou, faça login novamente.', true);
      } else if (validateEstudante) {
        next({ name: 'estudante-confirma' });
      } else {
        next();
      }
    } else {
      next();
    }
  } else if (name == 'login-entidade') {
    if (entidadeValida) {
      if (currentDate < experidTokenSie) {
        next({ name: 'criar-solicitacao' });
      } else {
        GlobalStore.setSnackBar({
          show: true,
          message: 'Sua sessão expirou, faça login novamente.',
          type: 'warning',
          timeout: 4000,
        });
        AuthService.logout(true);
      }
    } else {
      next();
    }
  } else if (name == 'login-grafica') {
    if (graficaValida) {
      if (currentDate < experidTokenSie) {
        next({ name: 'lote' });
      } else {
        GlobalStore.setSnackBar({
          show: true,
          message: 'Sua sessão expirou, faça login novamente.',
          type: 'warning',
          timeout: 4000,
        });
        AuthService.logout(false);
      }
    } else {
      next();
    }
  } else {
    next();
  }
});
